import { Layout } from "antd";
import { Navigate } from "react-router";

import { useGetLocation } from "@/entities/location";
import { isError404 } from "@/services/api";
import { useIdParam } from "@/services/router";

import { LocationPageHeader } from "./location-page-header";
import { LocationPageTabs } from "./location-page-tabs";

const { Content } = Layout;

export const LocationPage = () => {
  const id = useIdParam();
  const { isLoading, location, error } = useGetLocation(id);

  if (!id || isError404(error)) {
    return <Navigate to="/locations" replace />;
  }

  return (
    <>
      <LocationPageHeader location={location} loading={isLoading} />
      <Content>
        <LocationPageTabs location={location} loading={isLoading} />
      </Content>
    </>
  );
};

export default LocationPage;
